























































































import Vue from 'vue'
import { State, Getter, Mutation } from 'vuex-class'
import { Component, Prop, Watch } from 'vue-property-decorator'

import "blip-cards/dist/blip-cards.css"

import ThreadMessages from '@/components/ThreadMessages'
import MessageInput from '@/components/MessageInput'
import UnauthorizedDomain from '@/components/UnauthorizedDomain'
import LoadingScreen from '@/components/LoadingScreen'
import WelcomeScreen from '@/components/WelcomeScreen'
import ErrorLabel from '@/components/ErrorLabel'
import WebView from '@/components//WebView'

import {
  ConfigurationsCommandProcessor,
  MessageCommandProcessor,
  AccountCommandProcessor,
  AccountClient,
} from '@/api'
import { CommandProcessor } from '@/api/CommandProcessor'
import { BlipAccount } from '@/models'
import {
  Misc,
  PostMessageProcessor,
  UserPermissions,
  UserManager,
  EventUtils,
  BotAccountUtils,
} from '@/utils'
import { AppSettings } from '@/appSettings'

import defaultBotImage from '@/assets/images/avatar-default.png'
import { Mobile } from './utils/Mobile'

import { ErrorHandler } from './utils/ErrorHandler'
import { SentryClient } from 'monitoring-error-handler'

import BlipCardsTranslations from '@/i18n/blip-cards.js'

const APP_KEY = Misc.getQueryParam('appKey', true) || ''
const AUTH_TYPE = Misc.getQueryParam('authType') || AppSettings.get('GUEST_AUTH')
const OPEN_IMAGE_IN_FRAME = Misc.getQueryParam('openImageInFrame', false) || false

console.log('Captured query params', APP_KEY, AUTH_TYPE)

@Component({
  components: {
    ThreadMessages,
    MessageInput,
    UnauthorizedDomain,
    LoadingScreen,
    WelcomeScreen,
    WebView,
    ErrorLabel,
  },
})
export default class App extends Vue {
  customSendMessage: object = {}
  accountStatus: string = ''
  hasPermissionOnDomain: boolean = true
  isbotActive:boolean = true
  isCorrectBotKey: boolean = true
  isClientOffline: boolean = false
  culture: string = 'pt'
  isReadyToGet: boolean = false
  AccountClient: AccountClient = new AccountClient()
  botWelcomeMessage: string = ''
  botStartButton: string = ''
  botStartButtonLabel: string = ''
  showCloseButton: Boolean = false
  disableHistory: Boolean = false
  contentFilterRegex: string = ''
  @State client
  @State app
  @Getter botIdentity
  @Getter botAccountData: BlipAccount
  @Getter displayName: string
  @Mutation('setBotIdentity') mutationBotIdentity
  @Mutation('setApplicationLoading') mutationApplicationLoading
  @Mutation('setBotAccountData') mutationBotAccountData
  @Mutation('setOpenImageInFrame') mutationOpenImageInFrame

  
  get botPhoto() {
    return this.botAccountData.photoUri || defaultBotImage
  }

  get isApplicationLoading() {
    return this.app.applicationLoading
  }

  set isApplicationLoading(value) {
    this.mutationApplicationLoading(value)
  }

  get shouldWelcome() {
    return (
      this.botWelcomeMessage &&
      this.botStartButton &&
      this.botStartButtonLabel &&
      !this.client.hasMessages
    )
  }

  created() {
    EventUtils.newInstance()
  }

  errorCaptured(err, _, where) {
    ErrorHandler.handle(err, where)
  }

  async mounted() {
    //Add event to listen to postMessages
    window.addEventListener('message', (event) =>
      this.onReceivePostMessage(event)
    )

    /**
     * Send notification to parent window that blip chat is ready to receive data
     */
    PostMessageProcessor.send({ code: AppSettings.get('CHAT_READY_CODE') })

    //Get bot identifier from APP_KEY url parameter
    const { botIdentifier, botKey } = Misc.decodeBlipKey(APP_KEY)

    // Commit bot identity
    this.mutationBotIdentity(botIdentifier)

    //Commit is configuration uri open image in frame
    this.mutationOpenImageInFrame(OPEN_IMAGE_IN_FRAME) 

    // When there is no parent window should create new user and connect
    if (!Misc.hasParentWindow()) {
      const userData = UserManager.createGuestUser(botIdentifier)

      if (AppSettings.get('ENABLE_SENTRY_MONITORING') === 'true') {
        SentryClient.identifyUser({ id: userData.userIdentity })
      }

      await this.AccountClient.connectUser(userData)

      try {
        const resource =  await ConfigurationsCommandProcessor.getConfigGateway(this.botIdentity)

        if (resource) {
           this.contentFilterRegex = resource.resource.ContentFilterRegex || ''
        }
      } catch(e) {
        console.log(`Error on get bot ${botIdentifier} configuration`, e)
      }
      
      this.setupThread()
    }
  }

  async setupThread() {
    // Get bot botAccount with allowed domains
    const {
      resource: {
        extras: {
          'blipchat-domains': domains,
          'blipchat-app-key': key,
          'tenantId': tenantId,
          ...extras
        },
        ...resource
      },
    } = await AccountCommandProcessor.get(this.botIdentity)
    
    if (resource.culture) {
      this.culture = resource.culture.slice(0, 2)
    }

    //Check validation of bot key from APP_KEY url parameter
    const { botKey, botIdentifier } = Misc.decodeBlipKey(APP_KEY)
    this.isCorrectBotKey = botKey === key

    const accountDomains = domains || ''

    this.hasPermissionOnDomain = UserPermissions.hasPermissionsOnDomain(
      accountDomains
    )

    if (!this.hasPermissionOnDomain || !this.isCorrectBotKey) {
      console.error(!this.hasPermissionOnDomain ? 'Error validating domain permission' : `Wrong ApiKey for bot ${botIdentifier}`)
      return
    }

    try {
      const { resource: resourceApplicationAccountActive } = await AccountCommandProcessor.getAccountStatus(this.botIdentity)

       if (resourceApplicationAccountActive !== undefined && resourceApplicationAccountActive.isActive === false)
       {
         console.error(`This bot ${botIdentifier} is inactive`)
         return
       }

    } catch(e) {
      console.log(`Error on check if bot ${botIdentifier}`, e)
    }

    this.mutationBotAccountData({ ...resource, extras })
    console.log('BotAccount details', this.botAccountData)

    if (!this.client.hasMessages) {
      await this.getWelcomeInfo()
    }

    try {
      // Customize blip chat with bot configs
      new BotAccountUtils().setupBotAppearanceConfigs(this.botAccountData)
      // Get bot offline/online status
      this.accountStatus = await AccountCommandProcessor.status(
        this.botIdentity
      )
    } catch (e) {
      console.log('Error on bot config setup (color, display name, status)', e)
    }

    // Verify user connection
    this.client.instance.onListeningChanged = (listening, client) => {
      this.isClientOffline = !listening
    }

    // Get messages history
    // Tells to threadMessage add listeners and get messages with correct instance
    this.isReadyToGet = true

    // Tells to chat's parent that its ready to execute onLoad listener
    PostMessageProcessor.send({ code: AppSettings.get('CHAT_CONNECTED_CODE') })

    if (tenantId) {
      this.redirectIfNotUsingTenantIdOnUrl(tenantId)
    }
  }

  redirectIfNotUsingTenantIdOnUrl(tenantId: string) {
    const location = window.location.host.toLowerCase();
    if (!location.startsWith(tenantId.toLowerCase())) {
      if(!Misc.hasParentWindow()) {
        window.location.href = this.getNewUrl(tenantId, true)
      } else {
        PostMessageProcessor.send({code: AppSettings.get('GOOGLE_ANALYTICS_EVENT_NAME'), url: this.getNewUrl(tenantId)})
      }
    }
  }

  getNewUrl = (tenantId: string, withProtocol = false) =>
    withProtocol
      ? `${window.location.protocol}//${tenantId}.${window.location.host}/${window.location.search}`
      : `${tenantId}.${window.location.host}/${window.location.search}`

  applyCustomStyle(style) {
    const sheet = document.createElement('style')
    sheet.innerHTML = style
    document.body.appendChild(sheet)
  }

  async getWelcomeInfo() {
    try {
      // Get bot start button
      const startButtonResource = await AccountCommandProcessor.startButton(
        this.botIdentity
      )
      this.botStartButton = startButtonResource.resource

      // Get bot start button label
      const startButtonLabelResource = await AccountCommandProcessor.startButtonLabel(
        this.botIdentity
      )
      this.botStartButtonLabel = startButtonLabelResource.resource

      // Get bot welcome message
      const welcomeMessageResource = await AccountCommandProcessor.welcomeMessage(
        this.botIdentity
      )
      this.botWelcomeMessage = welcomeMessageResource.resource
    } catch (e) {}
  }

  sendStartMessage(botStartButton) {
    this.$emit('sendMessage', botStartButton)
  }

  async onReceivePostMessage(event) {
    console.log('event ' + event.data.code);
    switch (event.data.code) {
      case AppSettings.get('START_CONNECTION_CODE'):
        // Signal to start connection with server using received data
        let userAccount = Misc.deobfuscate(event.data.userAccount)
        let connectionData = Misc.deobfuscate(event.data.connectionData)
        this.disableHistory = event.data.disableHistory || false

        if (AUTH_TYPE === AppSettings.get('GUEST_AUTH') && !userAccount) {
          const { botIdentifier, botKey } = Misc.decodeBlipKey(APP_KEY)
          userAccount = UserManager.createGuestUser(botIdentifier)
        }

        if (AppSettings.get('ENABLE_SENTRY_MONITORING') === 'true') {
          SentryClient.identifyUser({ id: userAccount.userIdentity })
        }

        const newAccount = await this.AccountClient.connectUser(
          userAccount,
          connectionData
        )

        // Send new account to parent page storage on local storage (if guest auth)
        if (newAccount) {
          userAccount.authType = AUTH_TYPE
          userAccount = Misc.obfuscate(userAccount)
          PostMessageProcessor.send({
            code: AppSettings.get('CREATE_ACCOUNT_CODE'),
            userAccount,
          })
        }

        this.setupThread()
        break
      case AppSettings.get('SEND_MESSAGE_CODE'):
        console.log(event)
        // Signal to send message to bot as user
        if (typeof event.data.content === 'object') {
          MessageCommandProcessor.send(
            this.customSendMessage,
            event.data.content
          )
        } else {
          MessageCommandProcessor.send(this.customSendMessage, {
            type: 'text/plain',
            content: event.data.content,
            metadata: undefined,
          })
        }
        break
      case AppSettings.get('SEND_COMMAND_CODE'):
        // Signal to send command to bot as user
        await CommandProcessor.processCommand(event.data.command)
        break
      case AppSettings.get('KEYBOARD_STATE_CODE'):
        console.log('Receive keyboard state', event.data)

        Mobile.setKeyboardOpen(event.data.isOpen)
        break
      case AppSettings.get('SHOW_CLOSE_BUTTON'):
        // Signal to show close button on header
        this.showCloseButton = event.data.showCloseButton
        break
      // WebView events
      case AppSettings.get('CLOSE_WEBVIEW_CODE'):
        EventUtils.CloseWebview()
        break
      case AppSettings.get('OVERRIDE_CLOSE_CODE'):
        EventUtils.OpenWebview()
        break
      case AppSettings.get('USER_IRIS_ACCOUNT'):
        const account = event.data.account
        await AccountCommandProcessor.update(account)
        break
      case AppSettings.get('SET_PRESENCE_AVAILABLE'):
        AccountCommandProcessor.setPresence('available', 'promiscuous')
        break
      case AppSettings.get('SET_PRESENCE_UNAVAILABLE'):
        AccountCommandProcessor.setPresence('unavailable')
        break
      case AppSettings.get('CUSTOM_STYLE_CODE'):
        const customStyle = event.data.customStyle
        if (customStyle) this.applyCustomStyle(customStyle)
        break
      case AppSettings.get('CUSTOM_MESSAGE_METADATA'):
        if (event.data.customMessageMetadata) {
          this.customSendMessage = event.data.customMessageMetadata;
        }
        break
      default:
        break
    }
  }

  closeChat() {
    // Tells to chat's parent to close
    PostMessageProcessor.send({ code: AppSettings.get('CLOSE_WIDGET') })
  }

  translations() {
    const englishTexts = BlipCardsTranslations['en']
    const translationTexts = BlipCardsTranslations[this.culture]
    return translationTexts || englishTexts
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue